import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import '../styles/auth.css';

export default function ForgotPassword() {
  const [email, setEmail]   = useState('');
  const [sent, setSent]     = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>

          {sent ? (
            <>
              <h1 className="auth-heading">Check your inbox</h1>
              <p className="auth-sub">
                If an account exists for <strong>{email}</strong>, we sent a reset link. Check your spam folder too.
              </p>
              <p className="auth-link"><Link to="/login">Back to login</Link></p>
            </>
          ) : (
            <>
              <h1 className="auth-heading">Forgot password?</h1>
              <p className="auth-sub">Enter your email and we'll send you a reset link.</p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    autoFocus
                  />
                </div>
                {error && <div className="error-message">{error}</div>}
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </form>

              <p className="auth-link"><Link to="/login">Back to login</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
